import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { RootState } from '../reducers/rootReducer';
import { getPickToursInProgress, setPickToursInProgress } from '../actions/orders.actions';
import { setLoading } from '../actions/loading.actions';
import { mapGetOrdersResponseToSetPickToursPayload } from './getPickTours.mappers';

import {
  BFF_ORDERS,
  BFF_STORES,
  SAGA_GET_PICK_TOURS_IN_PROGRESS,
  COMMERCIAL_CUSTOMER_SERVICE_DOWN,
  ORDER_SERVICE_ERROR,
  BFF_V2,
  PICKING_APIGEE_BASE_PATH,
} from '../../constants';

import { GetPickToursInProgressPayload, SetPickToursPayload } from '../actions/orders.types';
import { GetOrdersResponse } from './types';
import { ConfigAuthValues, APIError } from '../../types';
import { callAPI } from '../../utils';
import { handleApiErrors } from './utils';

const callGetPickToursInProgress = (orderCallData: GetPickToursInProgressPayload, configValues: ConfigAuthValues) => {
  return callAPI({
    method: 'GET',
    url: `${configValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V2}${BFF_STORES}/${orderCallData.fulfillmentStoreID}${BFF_ORDERS}?activeAssignedToursOnly=true`,
  });
};

export function* runGetPickToursInProgressSaga(action: {
  type: string;
  payload: GetPickToursInProgressPayload;
}): Generator<any, void, any> {
  yield put(setLoading({ sagaName: SAGA_GET_PICK_TOURS_IN_PROGRESS, isLoading: true }));

  const configValues = yield select((state: RootState) => state.config);
  try {
    const result = yield call(
      callGetPickToursInProgress,
      {
        fulfillmentStoreID: action.payload.fulfillmentStoreID,
      },
      configValues.authValues
    );
    const apiResponseData: GetOrdersResponse = result.data;
    const mappedPayload: SetPickToursPayload = mapGetOrdersResponseToSetPickToursPayload(apiResponseData);
    yield put(setPickToursInProgress(mappedPayload));

    if (apiResponseData.errors && apiResponseData.errors.length > 0) {
      const filteredErrors = apiResponseData.errors.filter(
        (err: APIError) =>
          !(
            err.code === COMMERCIAL_CUSTOMER_SERVICE_DOWN &&
            err.detail.toLowerCase().includes('unable to check upc validation flag')
          )
      );
      yield handleApiErrors(filteredErrors);
    } else if (apiResponseData.errors) {
      yield handleApiErrors(apiResponseData.errors);
    }
  } catch (error) {
    yield put(setPickToursInProgress({ pickToursByType: {} }));
    const errorMessage = error instanceof Error ? error.message : 'Unknown error during API call';
    const orderError: APIError[] = [{ id: '', code: ORDER_SERVICE_ERROR, detail: errorMessage }];
    yield handleApiErrors(orderError);
  } finally {
    yield put(setLoading({ sagaName: SAGA_GET_PICK_TOURS_IN_PROGRESS, isLoading: false }));
  }
}

export default function* watchGetPickToursInProgress() {
  yield takeEvery(getType(getPickToursInProgress), runGetPickToursInProgressSaga);
}
